import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {t} from 'i18next';
import BaseListContainer from '../../baseContainers/BaseListContainer';
import ActionLink from '../../components/ActionLink';
import CriteriaTextComponent from '../../components/criteria/CriteriaTextComponent';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import MobileUserImportService from '../../services/MobileUserImportService';
import { Accordion, AccordionTab, Chip, Column, DataTable, Ripple, classNames } from 'primereact';
import DivContainer from '../../components/DivContainer';
import ActionButton from '../../components/ActionButton';
import CriteriaDropdownComponent from '../../components/criteria/CriteriaDropdownComponent';

class ImportLogList extends BaseListContainer {
    constructor(props) {
        super(props, new MobileUserImportService());
        this.state = {
            list: [],
            loading: true,
            size: 0,
            first: 0,
            criteria: this.getCleanSearchCriteria(),
            statusOptions: [
                {
                    label: 'Zaimportowano',
                    enumValue: 'IMPORTED',
                },
                {
                    label: 'Niezaimportowano',
                    enumValue: 'NOT_IMPORTED',
                },
            ],
            roleOptions: [],
            expandedRows:[],
            userImportId: this.props.userImportId,
        };
        this.onRemoveAction = this.onRemoveAction.bind(this);
        this.userId = this.authService.getUserId();
        this.handleOnRowToggle=this.handleOnRowToggle.bind(this);
    }
    getDataKey() {
        return 'id';
    }

    getListTitle() {
        return 'user.listTitle';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    updateSearchCriteria(criteria) {
        return {
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            roles: criteria.roles,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
            status: criteria.status,
            userFullName: criteria.userFullName
        };
    }

    getCleanSearchCriteria() {
        return {
            email: '',
            firstName: '',
            lastName: '',
            role: undefined,
            id: null,
            firstResult: 0,
            roles: [],
            maxResults: 10,
            sortField: 'id',
            sortAsc: true,    
            status: undefined,
            userFullName: '' 
           };
    }

    initializeFromBackend() {}

    getCriteriaName() {
        return 'import-log-list-sc';
    }

    getContainerListName() {
        return 'import-log-list-container';
    }

    rowExpansionTemplate(){

    }
    handleOnRowToggle(e) {
        this.setState({ expandedRows: e.data })
    }

    renderDataTable(columns, list, size) {
        const {criteria, first, loading} = this.state;
        if (list === null || list === undefined) {
            list = this.props.list ? this.props.list : this.state.list;
        }
        if (size === null || size === undefined) {
            size = this.props.list ? this.props.size : this.state.size;
        }
        const dynamicColumns = columns.map((col) => {
            return (
                <Column
                    selectionMode={col.selectionMode}
                    key={col.key ? col.key : col.field}
                    field={col.field}
                    filter
                    filterField={col.field}
                    showFilterMenu={false}
                    header={col.header}
                    body={col.body}
                    bodyClassName={col.bodyClassName}
                    headerClassName={col.headerClassName}
                    className={col.className}
                    sortable={col.sortable}
                    sortField={col.sortField !== undefined ? col.sortField : col.field}
                    style={col.width !== undefined ? {width: col.width} : null}
                    rowEditor={col.rowEditor}
                    editor={col.editor}
                    headerStyle={col?.headerStyle}
                    bodyStyle={this.getColumnBodyStyle(col)}
                    align={this.getColumnAlign(col)}
                />
            );
        });
        const rowsPerPageOptions = [5, 10, 20, 50, 100];
        return (
            <React.Fragment>
                <DivContainer colClass='row'>
                    <div className='datatable-responsive'>
                        <DataTable
                            id='dataTable'
                            key='data-table'
                            emptyMessage={t('list.empty')}
                            className='p-datatable-responsive'
                            breakpoint='10px'
                            value={list}
                            header={this.tableHeader()}
                            paginator
                            footerColumnGroup={this.generateCustomFooterIfPossible()}
                            globalFilterFields={this.globalFilterFields()}
                            filters={this.state.filters}
                            // filterDisplay='row'
                            rows={criteria.maxResults}
                            totalRecords={size}
                            first={first}
                            style={{
                                width: '880px'
                            }}
                            rowsPerPageOptions={rowsPerPageOptions}
                            sortField={criteria.sortField}
                            sortOrder={criteria.sortAsc ? 1 : -1}
                            loading={loading}
                            editMode='row'
                            paginatorPosition='bottom'
                            currentPageReportTemplate={
                                size !== 0
                                    ? `Pozycje od ${first + 1} do ${
                                          first + criteria.maxResults > size ? size : first + criteria.maxResults
                                      } z ${size} łącznie`
                                    : '0 pozycji'
                            }
                            paginatorTemplate={{
                                layout: 'RowsPerPageDropdown PrevPageLink PageLinks NextPageLink CurrentPageReport',
                                PrevPageLink: (options) => {
                                    if (criteria.firstResult === 0) {
                                        return null;
                                    } else {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={options.onClick}
                                                disabled={options.disabled}
                                            >
                                                <span className='p-paginator-icon pi pi-angle-left'></span>
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                                NextPageLink: (options) => {
                                    if (criteria.firstResult + criteria.maxResults >= size) {
                                        return null;
                                    } else {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={options.onClick}
                                                disabled={options.disabled}
                                            >
                                                <span className='p-paginator-icon pi pi-angle-right'></span>
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                                RowsPerPageDropdown: (options) => {
                                    return this.renderPagination(rowsPerPageOptions, options);
                                },
                                CurrentPageReport: (options) => {
                                    return <div className='p-paginator-dummy' />;
                                },
                                PageLinks: (options) => {
                                    if (options.view.startPage === options.page && options.view.startPage !== 0) {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={() => {
                                                    this.handlePage({first: 0, rows: this.state.criteria.maxResults});
                                                }}
                                            >
                                                {1}
                                                <Ripple />
                                            </button>
                                        );
                                    } else if (options.view.endPage === options.page && options.view.endPage !== options.totalPages - 1) {
                                        return (
                                            <button
                                                type='button'
                                                className={options.className}
                                                onClick={() => {
                                                    this.handlePage({
                                                        first: (options.totalPages - 1) * this.state.criteria.maxResults,
                                                        rows: this.state.criteria.maxResults,
                                                    });
                                                }}
                                            >
                                                {options.totalPages}
                                                <Ripple />
                                            </button>
                                        );
                                    } else if (
                                        (options.view.startPage + 1 === options.page && options.view.startPage !== 0) ||
                                        (options.view.endPage - 1 === options.page &&
                                            options.view.endPage !== options.totalPages - 1 &&
                                            options.page !== options.totalPages - 1)
                                    ) {
                                        const className = classNames(options.className, {'p-disabled': true});
                                        return (
                                            <span className={className} style={{userSelect: 'none'}}>
                                                ...
                                            </span>
                                        );
                                    } else {
                                        return (
                                            <button type='button' className={options.className} onClick={options.onClick}>
                                                {options.page + 1}
                                                <Ripple />
                                            </button>
                                        );
                                    }
                                },
                            }}
                            pageLinkSize={this.getPageLinkSize()}
                            lazy={this.props.lazy}
                            onPage={this.handlePage}
                            onSort={this.handleSort}
                            selectionMode={'checkbox'}
                            onSelectionChange={this.handleOnSelectionChange}
                            selection={this.state.selectedList}
                            selectAll={this.state.selectAll}
                            onSelectAllChange={this.handleOnSelectAllChange}
                            dataKey={this.dataKey}
                            expandedRows={this.state.expandedRows}
                            onRowToggle={this.handleOnRowToggle}
                            onRowExpand={this.handleOnRowExpand}
                            onRowCollapse={this.handleOnRowCollapse}
                            rowExpansionTemplate={this.rowExpansionTemplate}
                            rowClassName={this.props.rowClassName}
                            selectionPageOnly={false}
                        >
                            {this.props.rowExpansionTemplate ? <Column expander headerStyle={{width: '3em'}}></Column> : null}
                            {this.props.disableSelection === true || !this.props.selectionMode ? null : (
                                <Column selectionMode={this.props.selectionMode} headerStyle={{width: '3em'}}></Column>
                            )}
                            {dynamicColumns}
                        </DataTable>
                    </div>
                </DivContainer>
            </React.Fragment>
        );
    }
    
    getList() {
        const { criteria } = this.state;
        const activeElement = document.activeElement;
        this.setState(
            {
                loading: false,
            },
            () => {
                
                this.service
                    .getImportLogList(criteria,this.state.userImportId)
                    .then((data) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: this.updateListElements(data.content, this.props.userImportId),
                                    loading: false,
                                    size: data.totalElements,
                                },
                                () => {
                                    this.onAfterGetList(data);
                                    this.setTimeout(() => activeElement?.focus(), 50);
                                }
                            );
                        }
                    })
                    .catch((err) => {
                        if (this._isMounted) {
                            this.setState(
                                {
                                    list: [],
                                    loading: false,
                                    size: 0,
                                },
                                () => {
                                    this.afterGetListError();
                                }
                            );
                        }
                    });
            }
        );
    }

    renderFilter() {
        const expandFilters =
            this.props.expandFilters === null || this.props.expandFilters === undefined || this.props.expandFilters === true;
        return !this.props.hideFilters ? (
            <Accordion className='filter-accordion' activeIndex={expandFilters ? 0 : -1} style={{width: '905px'}}>
                <AccordionTab
                    header={
                        <React.Fragment>
                            <img className='card-icon' alt={t('list.filter')} src={`/images/ico_filter.svg`} />
                            <span>{t('list.filter')}</span>
                        </React.Fragment>
                    }
                >
                    <form
                        className='form-search-criteria'
                        onSubmit={(e) => {
                            this.handleFormSubmit(e);
                        }}
                        onKeyDown={(e) => this.onKeyDown(e)}
                        //avoid setting red border just after the page has loaded (red border because of undefined required value in FF)
                        noValidate
                    >
                        <DivContainer colClass='col-12'>
                            {this.renderCriteria()}
                            {
                                <DivContainer colClass='row'>
                                    <DivContainer colClass='col-md-12 text-right'>
                                        {' '}
                                        {/* Użyto text-right dla wyrównania do prawej */}
                                        <ActionButton
                                            className='btn' // Dodano klasę btn dla przycisku, mr-2 dla odstępu
                                            label='Wyczyść'
                                            handleClick={this.cleanSearchCriteria}
                                        />
                                        <ActionButton
                                            className='btn margin-left-8 ' // Dodano klasę btn dla przycisku
                                            label='Filtruj'
                                            handleClick={this.handleFormSubmit}
                                        />
                                    </DivContainer>
                                </DivContainer>
                            }
                        </DivContainer>
                    </form>
                </AccordionTab>
            </Accordion>
        ) : null;
    }


    renderCriteria() {
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='userFullName-sc'
                    name='userFullName'
                    label={t('importlog.username')}
                    colClass='col-lg-4 col-sm-6'
                    value={this.state.criteria.userFullName}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
                <CriteriaDropdownComponent
                    id='status-sc'
                    name='status'
                    label={t('importlog.status')}
                    colClass='col-lg-4 col-sm-6'
                    options={this.state.statusOptions}
                    value={this.state.criteria.status}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                />
            </div>
        );
    }

    prepareColumns() {
        return [
            {field: 'csvRecordNumber', header: 'ID rekordu', sortable: true, width: '50px'},
            {field: 'userFullName', header: 'Użytkownik', sortable: true, width: '50px'},
            {field: 'status', header: 'Status', sortable: true, width: '10px',
                body:(value) => {
                    const color = value.status === 'IMPORTED' ? 'green' : 'red';
                    const label = value.status === 'IMPORTED' ? 'Zaimportowano' : 'Niezaimportowano';
                    return (
                        <Chip style={{ color: color }} label={label} />
                    );
                }
            },
        ];
    }
    roleTemplate(rowData) {
        return rowData.roles ? rowData.roles.map((r) => t(`UserRoleType.${r}`)).join(', ') : '';
    }
    breadCrumbItems() {
        return [{name: ''}];
    }
    prepareHeaderItems() {
    }

    actionTemplate(rowData) {
        return (
            <div>
                <ActionLink
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenEditDialog(e, rowData.id)}
                    variant='blue'
                    iconName='mdi-eye'
                    iconSide='left'
                    iconSize='mdi-24px'
                    iconColor='blue'
                />
                <ActionLink
                    className='p-link float-right'
                    handleClick={(e) => this.handleOpenRemoveDialog(e, rowData.id)}
                    variant='red'
                    iconName='mdi-trash-can'
                    iconSide='left'
                    iconSize='mdi-24px'
                    iconColor='red'
                    rendered={rowData.id !== this.userId}
                />
            </div>
        );
    }

    render() {
        return (
            <div className='container-fluid'>
                {this.renderView()}
            </div>
        );
    }
    onRemoveAction(callback) {
        this.blockUi();
        this.service
            .remove(this.state.idToRemove)
            .then(() => {
                callback();
            })
            .catch((err) => {
                this.showErrorMessage(err.message);
                this.unblockUi();
                this.hideDeleteDialog();
            });
    }
}

ImportLogList.defaultProps = {
    lazy: true,
};

ImportLogList.propTypes = {
    editUrl: PropTypes.string,
    detailsUrl: PropTypes.string,
    newUrl: PropTypes.string,
};

export default withRouter(withTranslation()(ImportLogList));
